import React from 'react';
import '../../pages/page-styles.scss';
import { useStaticQuery, graphql } from 'gatsby';
import renderRichText from '../../utils/renderRichText';
import logo from '../../images/logo-final.png';

const Mission = () => {
  const data = useStaticQuery(graphql`
    {
      contentfulAbout(title: { eq: "Mission" }) {
        title
        content {
          raw
        }
      }
    }
  `);

  const { contentfulAbout } = data;
  const content = JSON.parse(contentfulAbout.content.raw);
  const title = contentfulAbout.title;

  return (
    <section className="section mountains-bg anchor" id="Mission">
      <div className="container">
        <div className="hero">
          <div className="columns">
            <div className="column is-4"></div>
            <div className="column">
              <img className="logo-image" src={logo} alt={logo.toString()} />
              <h3 className="is-size-3 title is-size-3-mobile has-text-left-desktop pr-4">
                {title.toUpperCase()}
              </h3>
              <div className="content">{renderRichText(content)}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
